var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('polygon',{attrs:{"points":"19.48 6.27 17.7 4.48 11.98 10.2 6.27 4.48 4.48 6.27 10.2 11.98 4.48 17.7 6.27 19.48 11.98 13.77 17.7 19.48 19.48 17.7 13.77 11.98 19.48 6.27"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }